import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29 16c0-7.18-5.82-13-13-13S3 8.82 3 16s5.82 13 13 13 13-5.82 13-13M5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16m11 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4.5-7.5a4.5 4.5 0 1 0-9 0 1 1 0 0 0 2 0l.005-.164A2.5 2.5 0 1 1 16 16.001a1 1 0 0 0-1 1v1l.007.116a1 1 0 0 0 .993.884l.117-.007A1 1 0 0 0 17 18l-.001-.113.236-.06a4.5 4.5 0 0 0 3.265-4.327"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHelp = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHelp);
export default Memo;
